export const rowStyles = {
  justifyContent: 'flex-start',
  textTransform: 'none',
  py: 1.25,
  px: 1.5,
  gap: 1.25,
};

export const stackRootStyles = { width: 320, p: 1 };
export const headerBoxStyles = {
  display: 'flex',
  flexDirection: 'column',
  px: 1.5,
  pt: 1,
  pb: 0.5,
};
export const eyebrowStyles = { mb: 0.25 };
export const titleStyles = { wordBreak: 'break-word' };

export const getFooterBoxStyles = theme => ({
  display: 'flex',
  justifyContent: 'flex-end',
  pt: 0.5,
  borderTop: `1px solid ${theme.palette.divider}`,
});
